import { cadastro_de_solicitacao_de_servico } from "./cadastro-de-solicitacao-de-servico";

const manutencao_de_matriculas = [...cadastro_de_solicitacao_de_servico];

export { manutencao_de_matriculas };
